import { InputAdornment, Typography } from "@mui/material";
import { ReactElement } from "react";

import { palette } from "~frontend/theme";

export function DollarAdornment(): ReactElement {
  return (
    <InputAdornment position="start" sx={{ marginLeft: 1, marginRight: -1 }}>
      <Typography display="inline" variant="h2" sx={{ color: palette.navy }}>
        $
      </Typography>
    </InputAdornment>
  );
}
